import React from "react";
import Navigation from '../components/Navigation';

const NotFound = () => {
    return(
        <div>
            <Navigation/>
            <h1>ERREUR 404</h1>
            <p>
                page de contact
            </p>
        </div>
    )
}

export default NotFound